import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import supabase from "../../supabase";
import { useNotification } from "../../context/NotificationContext";

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (sessionId) {
      updatePlan();
    }
  }, [sessionId, updatePlan]);

  const updatePlan = async () => {
    const { error } = await supabase
      .from("profiles")
      .update({ plan: "Premium" }) // Remplace selon le plan acheté
      .eq("id", "USER_ID"); // Mettre à jour en fonction du user.id récupéré

    if (!error) {
      showNotification("Paiement confirmé !", "success");
      navigate("/account");
    } else {
      showNotification("Erreur de mise à jour du plan.", "danger");
      console.error("Erreur de mise à jour :", error);
    }
  };

  return (
    <div className="text-center mt-5">
      <h2>Paiement réussi !</h2>
      <p>Redirection...</p>
    </div>
  );
};

export default SuccessPage;
